import { FullPeople, Identities } from '@/reports/types/people';
import { Card, Stack, Text, styled } from '@/theme/index';

export const OwnerSearchResultsCardContainer = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '275px',
  height: '300px',
  margin: '8px',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const OwnerSearchResultsCardAddressContainer = styled(Stack)(
  ({ theme }) => ({
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    height: '70px',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  })
);

export const renderOwnersDynamically = (
  owners: Identities | FullPeople,
  count?: number
) => {
  if (owners?.length === 0) {
    return <Text variant="h4">No owners found</Text>;
  }

  const ownersCount = count || owners?.length;

  return owners?.slice(0, ownersCount).map((owner) => {
    const names = 'names' in owner ? owner.names : owner.identity.names;
    return <Text variant="subtitle2">{names[0].full}</Text>;
  });
};
